/**
 * Records plays of players that have no script of their own (the home page
 * welcome video, YouTube embeds in blog posts) for the dashboard's Video &
 * Podcast Plays table. Mark the element with data-media-play="<catalog key>"
 * (services/media/MediaPlayCatalog.js); each counts once per page view.
 *
 *  - <video data-media-play>: its first play event.
 *  - <iframe data-media-play>: a cross-origin player gives no events, so a
 *    click into it is read from the window losing focus to that iframe.
 */

import { trackMediaPlay } from '../utils/trackMediaPlay.js';

function initMediaPlayTracking() {
    document.querySelectorAll('video[data-media-play]').forEach((video) => {
        video.addEventListener('play', () => trackMediaPlay(video.dataset.mediaPlay), { once: true });
    });

    const frames = new Set(document.querySelectorAll('iframe[data-media-play]'));
    if (!frames.size) return;
    window.addEventListener('blur', () => {
        // activeElement moves to the iframe just after the blur event
        setTimeout(() => {
            const frame = document.activeElement;
            if (!frames.has(frame)) return;
            frames.delete(frame);
            trackMediaPlay(frame.dataset.mediaPlay);
        }, 0);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMediaPlayTracking);
} else {
    initMediaPlayTracking();
}
